<template>
    <div>
        <HeaderBg :title="$t('adminInvestorPageData.title')" />

        <div class="form_container">
            <form @submit.prevent="addHome">
                <h2 class="sections-title">{{$t('adminInvestorPageData.sectionOne')}}</h2>
                <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.sectionOneImageAr')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionOneImgUrl == ''">
                        <img :src="sectionOneImgUrl" alt="" v-if="sectionOneImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionOneImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.sectionOneImageEn')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionOneImgUrlEn == ''">
                        <img :src="sectionOneImgUrlEn" alt="" v-if="sectionOneImgUrlEn !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionOneImgUrlEn] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[0].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[0].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[0].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[0].translations[1].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[0].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[0].translations[1].description" />
                    </client-only>
                </div>
                <hr>


                <h2 class="sections-title">{{$t('adminInvestorPageData.sectionTwo')}}</h2>
                <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.sectionTwoImageAr')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionTwoImgUrl == ''">
                        <img :src="sectionTwoImgUrl" alt="" v-if="sectionTwoImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionTwoImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.sectionTwoImageEn')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionTwoImgUrlEn == ''">
                        <img :src="sectionTwoImgUrlEn" alt="" v-if="sectionTwoImgUrlEn !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionTwoImgUrlEn] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[1].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[1].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[1].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[1].translations[1].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[1].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[1].translations[1].description" />
                    </client-only>
                </div>
                <hr>


                <h2 class="sections-title">{{$t('adminInvestorPageData.sectionThree')}}</h2>
                <!-- <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.imageLabel')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionThreeImgUrl == ''">
                        <img :src="sectionThreeImgUrl" alt="" v-if="sectionThreeImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionThreeImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[2].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[2].translations[1].title">
                </div>

                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[2].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[2].translations[1].sub_title">
                </div> -->
                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[2].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[2].translations[1].description" />
                    </client-only>
                </div> -->


                <h2 class="sections-title">{{$t('adminInvestorPageData.sectionFour')}}</h2>
                <!-- <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.imageLabel')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionFourImgUrl == ''">
                        <img :src="sectionFourImgUrl" alt="" v-if="sectionFourImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionFourImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[3].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[3].translations[1].title">
                </div>

                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[3].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[3].translations[1].sub_title">
                </div> -->
                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[3].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[3].translations[1].description" />
                    </client-only>
                </div> -->
                <h2 class="sections-title">{{$t('adminInvestorPageData.sectionFive')}}</h2>
                <!-- <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.imageLabel')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionFiveImgUrl == ''">
                        <img :src="sectionFiveImgUrl" alt="" v-if="sectionFiveImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionFiveImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[4].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[4].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[4].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[4].translations[1].sub_title">
                </div>
                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionAr')}}</label>
                    <div class="money-market-disclosure">

                        <div
                            v-for="(des, i) in home.sections[4].translations[0].money_market_disclosure"
                            :key="i"
                            class="disclosure-item"
                        >
                            <input
                            type="text"
                            v-model="home.sections[4].translations[0].money_market_disclosure[i]"
                            class="disclosure-input"
                            />
                            <button
                            type="button"
                            class="delete-btn"
                            @click="removeDisclosure(i)"
                            >
                            🗑 Delete
                            </button>
                        </div>
                        <button
                            type="button"
                            class="add-btn"
                            @click="addDisclosure"
                        >
                            + Add New
                        </button>
                    </div>

                </div> -->
                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionEn')}}</label>
                    <div class="money-market-disclosure">

                        <div
                            v-for="(des, i) in home.sections[4].translations[1].money_market_disclosure"
                            :key="i"
                            class="disclosure-item"
                        >
                            <input
                            type="text"
                            v-model="home.sections[4].translations[1].money_market_disclosure[i]"
                            class="disclosure-input"
                            />
                            <button
                            type="button"
                            class="delete-btn"
                            @click="removeDisclosureEn(i)"
                            >
                            🗑 مسح
                            </button>
                        </div>
                        <button
                            type="button"
                            class="add-btn"
                            @click="addDisclosureEn"
                        >
                            + أضف جديد
                        </button>
                    </div>
                </div> -->
                <h2 class="sections-title">{{$t('adminInvestorPageData.sectionSix')}}</h2>
                <!-- <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.imageLabel')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionSixImgUrl == ''">
                        <img :src="sectionSixImgUrl" alt="" v-if="sectionSixImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionSixImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[5].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[5].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[5].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[5].translations[1].sub_title">
                </div>
                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[5].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[5].translations[1].description" />
                    </client-only>
                </div> -->
                <h2 class="sections-title">{{$t('adminInvestorPageData.sectionSeven')}}</h2>
                <!-- <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.imageLabel')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionSevenImgUrl == ''">
                        <img :src="sectionSevenImgUrl" alt="" v-if="sectionSevenImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionSevenImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[6].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[6].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[6].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[6].translations[1].sub_title">
                </div>
                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[6].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[6].translations[1].description" />
                    </client-only>
                </div> -->
                <h2 class="sections-title">{{$t('adminInvestorPageData.sectionEight')}}</h2>
                <!-- <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.imageLabel')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionEightImgUrl == ''">
                        <img :src="sectionEightImgUrl" alt="" v-if="sectionEightImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionEightImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[7].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[7].translations[1].title">
                </div>

                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[7].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[7].translations[1].sub_title">
                </div>
                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[7].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[7].translations[1].description" />
                    </client-only>
                </div> -->
                <h2 class="sections-title">{{$t('adminInvestorPageData.sectionNine')}}</h2>
                <!-- <div class="upload_img">
                    <span>{{$t('adminInvestorPageData.imageLabel')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="sectionNineImgUrl == ''">
                        <img :src="sectionNineImgUrl" alt="" v-if="sectionNineImgUrl !== ''">
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label for="">
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" v-on="{ change: [uploadSectionNineImgUrl] }">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleAr')}}</label>
                    <input type="text" v-model="home.sections[8].translations[0].title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.firstTitleEn')}}</label>
                    <input type="text" v-model="home.sections[8].translations[1].title">
                </div>

                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleAr')}}</label>
                    <input type="text" v-model="home.sections[8].translations[0].sub_title">
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.secondTitleEn')}}</label>
                    <input type="text" v-model="home.sections[8].translations[1].sub_title">
                </div> -->
                <!-- <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionAr')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[8].translations[0].description" />
                    </client-only>
                </div>
                <div class="input_container">
                    <label>{{$t('adminInvestorPageData.descriptionEn')}}</label>
                    <client-only>
                        <VueEditor  v-model="home.sections[8].translations[1].description" />
                    </client-only>
                </div> -->
                
                <div class="alert alert-success mt-2" role="alert" v-if="successMessage">
                    {{$t('adminInvestorPageData.successMessage')}}
                </div>
                <div class="alert alert-danger mt-2" role="alert" v-if="ErrorCheck == true">
                    <p v-for="(error, index) in errors" :key="index"> {{error}} </p>
                </div>
                <button class="saveBtn" v-if="postLoaded == false">
                    {{$t('adminInvestorPageData.save')}}
                </button>
                <button class="saveBtn" v-if="postLoaded == true"><b-spinner></b-spinner></button>
            </form>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import Request from '../../../services/Request';
import { VueEditor } from "vue2-editor";
export default {
    name :'InvestorPageData',
    components: {HeaderBg, VueEditor},
    data(){
        return{
            postLoaded: false,
            successMessage: false,
            sectionOneImgUrl: '',
            sectionOneImgUrlEn: '',
            sectionTwoImgUrl: '',
            sectionTwoImgUrlEn: '',
            sectionThreeImgUrl: '',
            sectionFourImgUrl: '',
            sectionFiveImgUrl: '',
            sectionSixImgUrl: '',
            sectionSevenImgUrl: '',
            sectionEightImgUrl: '',
            sectionNineImgUrl: '',

            // fourth section
            home: {
                sections: [
                    {
                        image: '',
                        image_en: '',
                        section: 1,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        image_en: '',
                        section: 2,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        section: 3,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        section: 4,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        section: 5,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        section: 6,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        section: 7,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        section: 8,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    },
                    {
                        image: '',
                        section: 9,
                        translations : [
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "ar"
                            },
                            {
                                title : "",
                                sub_title : "",
                                description : "",
                                locale : "en"
                            }
                        ]
                    }
                ]
            },
            errors: [],
            ErrorCheck: false,
        }
    },
    mounted(){
        this.getInvestorPageSectionOne();
        this.getInvestorPageSectionTwo();
        this.getInvestorPageSectionThree();
        this.getInvestorPageSectionFour();
        this.getInvestorPageSectionFive();
        this.getInvestorPageSectionSix();
        this.getInvestorPageSectionSeven();
        this.getInvestorPageSectionEight();
        this.getInvestorPageSectionNine();
    },
    methods:{
        addHome() {
            this.successMessage = false;
            this.postLoaded = true;
            this.errors = [];
            this.ErrorCheck = false;

            const formData = new FormData();

            // ✅ append images
            if (this.home.sections[0].image) {
                formData.append("sections[0][image]", this.home.sections[0].image);
            }
            if (this.home.sections[0].image_en) {
                formData.append("sections[0][image_en]", this.home.sections[0].image_en);
            }
            if (this.home.sections[1].image) {
                formData.append("sections[1][image]", this.home.sections[1].image);
            }
            if (this.home.sections[1].image_en) {
                formData.append("sections[1][image_en]", this.home.sections[1].image_en);
            }
            if (this.home.sections[2].image) {
                formData.append("sections[2][image]", this.home.sections[2].image);
            }
            if (this.home.sections[3].image) {
                formData.append("sections[3][image]", this.home.sections[3].image);
            }
            if (this.home.sections[4].image) {
                formData.append("sections[4][image]", this.home.sections[4].image);
            }
            if (this.home.sections[5].image) {
                formData.append("sections[5][image]", this.home.sections[5].image);
            }
            if (this.home.sections[6].image) {
                formData.append("sections[6][image]", this.home.sections[6].image);
            }
            if (this.home.sections[7].image) {
                formData.append("sections[7][image]", this.home.sections[7].image);
            }
            if (this.home.sections[8].image) {
                formData.append("sections[8][image]", this.home.sections[8].image);
            }
      
            // ✅ append translations (ar/en)
            this.home.sections.forEach((data, index) => {
                formData.append(`sections[${index}][section]`, data.section);
                data.translations.forEach((t, indexx) => {
                    Object.keys(t).forEach(key => {
                        formData.append(`sections[${index}][translations][${indexx}][${key}]`, t[key]);
                    });
                });   
            });

            

            axios.post("https://app.almujtama.com.sa/admin/investor_relations_page_sections", formData, {
                headers: { 
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "multipart/form-data"
                }
            })
            .then(() => {
                this.postLoaded = false;
                this.ErrorCheck = false;
                this.successMessage = true;
            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    this.errors = err.response.data.errors;
                    this.ErrorCheck = true;
                }
                this.postLoaded = false;
            });
        },
        uploadSectionOneImgUrl(e) {
            this.home.sections[0].image = e.target.files[0];
            this.sectionOneImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionOneImgUrlEn(e) {
            this.home.sections[0].image_en = e.target.files[0];
            this.sectionOneImgUrlEn = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionTwoImgUrl(e) {
            this.home.sections[1].image = e.target.files[0];
            this.sectionTwoImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionTwoImgUrlEn(e) {
            this.home.sections[1].image_en = e.target.files[0];
            this.sectionTwoImgUrlEn = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionThreeImgUrl(e) {
            this.home.sections[2].image = e.target.files[0];
            this.sectionThreeImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionFourImgUrl(e) {
            this.home.sections[3].image = e.target.files[0];
            this.sectionFourImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionFiveImgUrl(e) {
            this.home.sections[4].image = e.target.files[0];
            this.sectionFiveImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionSixImgUrl(e) {
            this.home.sections[5].image = e.target.files[0];
            this.sectionSixImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionSevenImgUrl(e) {
            this.home.sections[6].image = e.target.files[0];
            this.sectionSevenImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionEightImgUrl(e) {
            this.home.sections[7].image = e.target.files[0];
            this.sectionEightImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSectionNineImgUrl(e) {
            this.home.sections[8].image = e.target.files[0];
            this.sectionNineImgUrl = URL.createObjectURL(e.target.files[0]);
        },
  
        
        getInvestorPageSectionOne(){
            Request.fetch(`admin/investor_relations_page_sections/1`, '')
            .then((response) => {
                this.sectionOneImgUrl= response.data.data.image,
                this.sectionOneImgUrlEn= response.data.data.image_en,
                this.home.sections[0].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getInvestorPageSectionTwo(){
            Request.fetch(`admin/investor_relations_page_sections/2`, '')
            .then((response) => {
                this.sectionTwoImgUrl= response.data.data.image,
                this.sectionTwoImgUrlEn= response.data.data.image_en,
                this.home.sections[1].translations = response.data.data.translations;

            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getInvestorPageSectionThree(){
            Request.fetch(`admin/investor_relations_page_sections/3`, '')
            .then((response) => {
                this.sectionThreeImgUrl= response.data.data.image,
                this.home.sections[2].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getInvestorPageSectionFour(){
            Request.fetch(`admin/investor_relations_page_sections/4`, '')
            .then((response) => {
                this.sectionFourImgUrl= response.data.data.image,
                this.home.sections[3].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getInvestorPageSectionFive(){
            Request.fetch(`admin/investor_relations_page_sections/5`, '')
            .then((response) => {
                this.sectionFiveImgUrl= response.data.data.image,
                this.home.sections[4].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getInvestorPageSectionSix(){
            Request.fetch(`admin/investor_relations_page_sections/6`, '')
            .then((response) => {
                this.sectionFiveImgUrl= response.data.data.image,
                this.home.sections[5].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getInvestorPageSectionSeven(){
            Request.fetch(`admin/investor_relations_page_sections/7`, '')
            .then((response) => {
                this.sectionFiveImgUrl= response.data.data.image,
                this.home.sections[6].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getInvestorPageSectionEight(){
            Request.fetch(`admin/investor_relations_page_sections/8`, '')
            .then((response) => {
                this.sectionFiveImgUrl= response.data.data.image,
                this.home.sections[7].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getInvestorPageSectionNine(){
            Request.fetch(`admin/investor_relations_page_sections/9`, '')
            .then((response) => {
                this.sectionFiveImgUrl= response.data.data.image,
                this.home.sections[8].translations = response.data.data.translations;
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        addDisclosure() {
            // Add an empty string as a new disclosure input
            this.home.sections[4].translations[0].money_market_disclosure.push('');
        },

        removeDisclosure(index) {
            // Remove the disclosure at the selected index
            this.home.sections[4].translations[0].money_market_disclosure.splice(index, 1);
        },
        addDisclosureEn() {
            // Add an empty string as a new disclosure input
            this.home.sections[4].translations[1].money_market_disclosure.push('');
        },

        removeDisclosureEn(index) {
            // Remove the disclosure at the selected index
            this.home.sections[4].translations[1].money_market_disclosure.splice(index, 1);
        },
    }
}
</script>
<style lang="scss" scoped>
.form_container{
    background-color: #FFF;
    border-radius: 10px;
    margin: 40px auto;
    padding: 70px 100px;
    @media (max-width: 576px) {
        width: 97%;
        padding: 30px;
    }
    form{
        > div{
            margin-bottom: 40px;
            label{
                display: block;
                text-align: center;
                font-size: 16px;
                color: #717171;
                font-weight: 600;
                margin-bottom: 10px;
            }
            input{
                border: 1px solid #71717191;
                font-size: 16px;
                padding: 5px 10px;
                border-radius: 10px;
                display: block;
                margin: auto;
                width: 50%;
            }
        }
        button{
            margin: 30px auto 0 auto;   
        }
    }
}
.upload_img{
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            width: 100%;
            span{
                font-size: 16px;
                color: #656565;
                margin-inline-end: 50px;
            }
            .img_container{
                width: 80px;
                height: 80px;
                border-radius: 50%;
                background-color: #FAFAFA;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                img{
                    width: 100%;
                }
                .photo_upload{
                    
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    img{
                        width: 70%;
                    }
                }
            }
        }
        .money-market-disclosure {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.disclosure-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.disclosure-input {
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 6px;
}

.add-btn, .delete-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.add-btn:hover {
  background-color: #0056b3;
}

.delete-btn {
  background-color: #dc3545;
}

.delete-btn:hover {
  background-color: #b02a37;
}

</style>